import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "hs4210";

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.findbyCardCode = (cardCode) => {
  let api = {
    module: moduleName,
    type: "list",
    value: {
      filters: "cardCode=" + cardCode
    }
  };
  return ApiService(api);
};


moduleApi.detail = (hsId, SidCode) => {
  let api = {
    module: moduleName,
    type: "list",
    value: {
      filters:
        "hsId=" + hsId +
        "&sidCode=" + SidCode
    }
  };
  return ApiService(api);
};

moduleApi.requestOtp = (cardCode) => {
  let api = {
    module: moduleName,
    type: "requestOtp", //function mushroom
    value: {
      "cardCode": cardCode
    }
  };
  return ApiService(api);
};


moduleApi.validateOtp = (cardCode, otp) => {
  let api = {
    module: moduleName,
    type: "validateOtp",
    value: {
      "cardCode": cardCode,
      "otp": otp
    }
  };
  return ApiService(api);
};

// moduleApi.detailByOTPtoken = (hsId, SidCode, otp_token) => {
//   let api = {
//     module: moduleName,
//     type: "list",
//     value: {
//       filters:
//         "hsId=" + hsId +
//         "&sidCode=" + SidCode +
//         "&otp_token=" + otp_token
//     }
//   };
//   return ApiService(api);
// };

// new api, xem detail bỏ token
moduleApi.detailByCardCode = (hsId, SidCode, cardCode) => {
  let api = {
    module: moduleName,
    type: "list",
    value: {
      filters:
        "hsId=" + hsId +
        "&sidCode=" + SidCode +
        "&cardCode=" + cardCode
    },
    message: {
      success: "", //string | null | comment
      error: "Lỗi tải dữ liệu hoặc chưa có quyền truy cập",  //string | null | comment
    }
  };
  return ApiService(api);
};



export default moduleApi;
